
export default {
  download: 'Scaricare',
}
